import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { format } from 'date-fns';
import { es } from 'date-fns/locale';

function formatoPesos(value) {
    return '$ ' + value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function FormatoFechaSinHora(value) {
    const fecha = new Date(value);
    return format(fecha, 'dd-MMMM-yyyy', { locale: es }).toUpperCase();
}

function FormatoFechaConHora(value) {
    const fecha = new Date(value);
    return format(fecha, "dd-MMMM-yyyy HH:mm:ss", { locale: es }).toUpperCase();
}

function calcularAnchoProporcional(base64, alturaFija) {
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            const ancho = img.naturalWidth && img.naturalHeight
                ? (img.naturalWidth * alturaFija) / img.naturalHeight
                : 50;
            resolve(ancho);
        };
        img.onerror = () => resolve(50);
        img.src = base64;
    });
}

function detectarFormatoImagen(base64) {
    if (base64.startsWith('data:image/png'))  return 'PNG';
    if (base64.startsWith('data:image/jpeg')) return 'JPEG';
    if (base64.startsWith('data:image/jpg'))  return 'JPEG';
    if (base64.startsWith('data:image/gif'))  return 'GIF';
    if (base64.startsWith('data:image/webp')) return 'WEBP';
    return 'PNG';
}

const EstadoResultadosPDF = async (objEstadoResultados, objEmpresa, fechaI, fechaF) => {
    return new Promise(async (resolve, reject) => {
        try {
            const doc = new jsPDF({ format: 'letter' });

            const color               = objEmpresa?.color || '#662e91';
            const logoBase64          = objEmpresa?.logo?.base64 || '';
            const fechaHoraGeneracion = FormatoFechaConHora(new Date());

            const margenIzq = 12;
            const margenDer = 12;
            const anchoUtil = 215 - margenIzq - margenDer; // ~191mm
            const xDer      = 215 - margenDer;

            // ── CABECERA ──────────────────────────────────────────────────
            let y = 14;

            // Logo
            if (logoBase64 !== '') {
                const alturaLogo = 20;
                const formatoImg = detectarFormatoImagen(logoBase64);
                const anchoLogo  = await calcularAnchoProporcional(logoBase64, alturaLogo);
                doc.addImage(logoBase64, formatoImg, margenIzq, y, anchoLogo, alturaLogo);
            }

            // Título + datos empresa (derecha)
            doc.setFontSize(14);
            doc.setFont('helvetica', 'bold');
            doc.text('Estado de Resultados', xDer, y, { align: 'right' });

            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            doc.text((objEmpresa?.rfc || '') + ' | ' + (objEmpresa?.nombre || ''), xDer, y += 6, { align: 'right' });

            const periodo = 'PERIODO DEL ' + FormatoFechaSinHora(fechaI) + ' AL ' + FormatoFechaSinHora(fechaF);
            doc.text(periodo, xDer, y += 5, { align: 'right' });

            y += 10;

            // ── TABLA DE ESTADO DE RESULTADOS (autoTable) ─────────────────
            doc.autoTable({
                startY: y,
                head: [[
                    { content: '',       styles: { halign: 'center' } },
                    { content: 'Descripción', styles: { halign: 'left'   } },
                    { content: 'Importe',     styles: { halign: 'right'  } },
                ]],
                body: objEstadoResultados.map(c => ([
                    {
                        content: c.signo || '',
                        styles: {
                            halign:    'center',
                            fontStyle: c.signo === '=' ? 'bold' : 'normal',
                        }
                    },
                    {
                        content: c.descripcion || '',
                        styles: {
                            halign:    'left',
                            fontStyle: c.signo === '=' ? 'bold' : 'normal',
                        }
                    },
                    {
                        content: c.importe != '-' ? formatoPesos(c.importe) : '',
                        styles: {
                            halign:    'right',
                            fontStyle: c.signo === '=' ? 'bold' : 'normal',
                        }
                    },
                ])),
                styles: {
                    fontSize: 8,
                    cellPadding: 2,
                    overflow: 'linebreak',
                },
                headStyles: {
                    fillColor: color,
                    textColor: '#ffffff',
                    fontStyle: 'bold',
                },
                alternateRowStyles: { fillColor: '#f4f4f4' },
                columnStyles: {
                    0: { cellWidth: 12  },  // Signo
                    1: { cellWidth: 145 },  // Descripción
                    2: { cellWidth: 34  },  // Importe
                },
                margin: { left: margenIzq, right: margenDer },
                tableWidth: anchoUtil,
            });

            // ── PIE DE PÁGINA ─────────────────────────────────────────────
            const totalPages = doc.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
                doc.setPage(i);
                doc.setFont('helvetica', 'italic');
                doc.setFontSize(8);
                doc.setTextColor(150);

                const pageH = doc.internal.pageSize.getHeight();
                const pageW = doc.internal.pageSize.getWidth();

                doc.setDrawColor(color);
                doc.setLineWidth(0.3);
                doc.line(margenIzq, pageH - 16, pageW - margenDer, pageH - 16);

                doc.text('Generado: ' + fechaHoraGeneracion, margenIzq, pageH - 8, { align: 'left' });
                doc.text('Documento generado por ContaGo', pageW / 2, pageH - 8, { align: 'center' });
                doc.text('Página ' + i + ' de ' + totalPages, pageW - margenDer, pageH - 8, { align: 'right' });
            }

            const base64 = doc.output('datauristring');
            resolve(base64);
        } catch (error) {
            console.error(error);
            reject(error);
        }
    });
};

export { EstadoResultadosPDF };